import { useQuery } from 'react-query';
import { getFileUrl } from '../../api/studiesAPI';

const DownloadableAnchor = ({ fileName, qamId }) => {
	const { isLoading, data } = useQuery({
		queryKey: ['get-document-url', fileName],
		queryFn: () => getFileUrl(fileName, qamId),
		retry: false,
		staleTime: 240000
	});

	if (isLoading) {
		return <span>{fileName}</span>;
	}

	return (
		<a href={data.data.fileUrl} target='_blank'>
			{fileName}
		</a>
	);
};

export default DownloadableAnchor;
